import { Component, Input } from '@angular/core';
import { StepModel } from 'src/models/productImport/step.model';

@Component({
    selector: 'pim-pipeline-display',
    templateUrl: './pipeline-display.component.html',
    styleUrls: ['./pipeline-display.component.sass'],
    standalone: false
})
export class PipelineDisplayComponent {

	@Input()
	currentStepIndex!: number;

	@Input()
	steps!: StepModel[];

}
